var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-icondownload';
                    var viewUrl = 'gfx/sprite.svg#view-icon-icondownload';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 3 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };